import React from 'react';
import './faq.scss';
import {
    career,
    careerIntroEng,
    careerIntroHun,
    careerTitle
} from "../demo_page/content";

class Faq extends React.Component {
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }
    
    
    render() {
        const isEng = this.props.language && this.props.language === 'ENG';

        const itemList = career.map((val, i) => {
            return <div className="card border-theme mb-3 radius-0" key={i}>
                <div className="card-header" id={"heading" + i} data-toggle="collapse" data-target={"#collapse" + i} aria-expanded="false" aria-controls={"collapse" + i}>
                    <a>{isEng ? val.labelEng : val.labelHun}<i className="fa fa-angle-down"/></a>
                </div>

                <div id={"collapse" + i} className="collapse" aria-labelledby={"heading" + i} data-parent="#accordion">
                    <div className="card-body" dangerouslySetInnerHTML={{__html: isEng ? val.descEng : val.descHun}}/>
                </div>
            </div>;
        });
        
        return (
            <div id={'career'} className={"faq-personalized"}>
                
                <section>
                    <div className="innerpage-decor">
                        <div className="innerpage-circle1"><img src="assets/images/Testimonial2.png" alt="" /></div>
                        <div className="innerpage-circle2"><img src="assets/images/Testimonial1.png" alt="" /></div>
                    </div>
                    {/*faq in*/}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-sm-6 col-text-center d-align-center">
                                <h2 className="title">{isEng ? careerTitle.eng : careerTitle.hun}</h2>
                            </div>
                            <p className="caption-about" dangerouslySetInnerHTML={{__html: isEng ? careerIntroEng : careerIntroHun}}/>
                            <div className="col-md-6 col-sm-6 col-text-center">
                            </div>
                        </div>
                    </div>
                    <div className="faq">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div id="accordion">
                                        {itemList}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


export default Faq;


// WEBPACK FOOTER //
// ./src/components/faq.js